<template>
  <div class="bg-color">
    <v-container fluid class="home px-0">
      <hero/>
    </v-container>

    <v-container fluid-md id="about">
      <v-layout row wrap grid-list-md>
        <v-flex
          class="mb-5 pt-2"
          text-md-left
          text-xs-left
          xs12
          md5
        >
          <h2 class="primary--text">Hi! We're <br> TD&nbsp;LAB. <br>—</h2>
          <p>
            We’re an innovation team within TD focused on experiences "for students, by students"
            that look at the unique financial challenges of post-secondary life.
          </p>
          <p>
            Located in the Communitech hub, in Kitchener-Waterloo, our talented team combines a mix of
            developers, designers, business analysts and co-op interns who help us build the concepts
            <span class="text-italic"> they'd </span> <span>like to use.</span>
          <p> But don’t just take our word for it.</p>
          <p>
            We're asking the post-secondary students of Waterloo region to help us test them out,
            so we are truly putting the student at the centre of the experience.
          </p>
        </v-flex>
        <v-flex
          class="mb-5 pt-2"
          text-md-justify
          text-xs-left
          xs12
          md6
          offset-xs0
          offset-md1
        >
          <ig-feed />
        </v-flex>
      </v-layout>
    </v-container>

    <v-container grid-list-md fluid-md class="home-page">
      <v-layout row wrap justify-center>
        <v-flex
          xs12
          text-xs-left
        >
          <h2>
            Featured Prototypes
          </h2>
        </v-flex>

        <v-flex
          v-for="(project, index) in featuredProjectsSorted"
          :key="`${project.id}${index}`"
          xs12
          sm6
          md4
          lg4
          xl3
        >
          <v-hover>
            <v-card
              class="home-page-project"
              :color="(index % 2) ? 'grey lighten-2' : 'primary'"
              :dark="!(index % 2)"
              :class="`elevation-${hover ? 12 : 0}`"
              slot-scope="{ hover }"
              :to="`/project/${project.uri}`"
            >
              <v-flex class="content w-100 px-3">
                <div class="bg-img top-left">
                  <img :src="project.imageThumbnail">
                </div>
                <div class="bg-img top-right">
                  <img :src="project.imageThumbnail">
                </div>
                <div class="bg-img bottom-left">
                  <img :src="project.imageThumbnail">
                </div>
                <div class="bg-img bottom-right">
                  <img :src="project.imageThumbnail">
                </div>
              </v-flex>
              <v-flex class="content description w-100">
                <h3 class="mb-0">
                  {{project.title}}
                </h3>
                <p>
                  {{project.description}}
                </p>
              </v-flex>
            </v-card>
          </v-hover>
        </v-flex>
      </v-layout>
    </v-container>

    <v-container fluid-md >
      <v-layout row wrap justify-center>
        <v-flex
          xs12
          text-xs-middle
          class="my-5"
        >
          <v-btn
            round color="primary"
            class="mt-5"
            dark
            large
            to="/experiments/"
          >
            View All Experiments
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
</div>
</template>

<style lang="scss">
.bg-color {
  background: rgb(206, 206, 206);
  background: white;
}
.home-page {
  h2 {
    font-size: 45px;
    margin-bottom: 0.5em;
  }
  .project-type {
    position: absolute;
    top: 0;
    right: 0.5em;
    span {
      position: relative;
      left: 0.0125em;
      top: 0.0.9em;
      font-size: 1.125em;
    }
  }
  .home-page-project {
    position: relative;
    padding-top: 70%;
    @media only screen and (min-width: 600px) {
      padding-top: 70% !important;
      .content.description {
        padding-left: 32px !important;
      }
    }
    @media only screen and (min-width: 960px) {
      padding-top: 134% !important;
    }
    @media only screen and (min-width: 1264px) {
      padding-top: 100% !important;
    }
    background: red;
    .content {
      position: absolute;
      top: 0;
      height: 100%;
      overflow: hidden;
      &.description {
        padding-left: 30px !important;
        padding-right: 30px !important;
        padding-top: 21% !important;
        h3 {
          text-align: left;
          font-size: 3em;
          width: 80%;
          line-height: 1em;
          margin-bottom: -0.25em !important;
          &:after {
            content: '—';
            display: block;
          }
        }
        p {
          width: 100%;
          text-align: left;
          opacity: 0;
          transform: translateY(0px);
          transition-delay: 0.2s;
        }
      }
      .bg-img {
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0.2;
        filter: saturate(0) brightness(0.7) contrast(3);
        width: 100%;
        height: 100%;
        background-size: 100% 100%;
        object-fit: cover;
        overflow: hidden;
        img {
          position: absolute;
          top: -50%;
          left: -50%;
          width: 140%;
        }
        &.top-left {
          top: -50%;
          left: -50%;
          transition-delay: 0.15s;
          img {
            top: 50%;
            left: 50%;
          }
        }
        &.top-right {
          top: -50%;
          left: 50%;
          transition-delay: 0s;
          img {
            top: 50%;
            left: -50%;
          }
        }
        &.bottom-left {
          top: 50%;
          left: -50%;
          transition-delay: 0.05s;
          img {
            top: -50%;
            left: 50%;
          }
        }
        &.bottom-right {
          top: 50%;
          left: 50%;
          transition-delay: 0.1s;
          img {
            top: -50%;
            left: -50%;
          }
        }
      }
    }
    * {
      transition: all 0.5s ease;
      transform: translate3d( 0, 0, 0)
    }
    &:hover {
      .bg-img {
        filter: saturate(1) brightness(0.5) contrast(1);
        opacity: 0.4;
        &.top-left {
          top: -95%;
          left: -50%;
        }
        &.top-right {
          top: -50%;
          left: 95%;
        }
        &.bottom-left {
          top: 50%;
          left: -95%;
        }
        &.bottom-right {
          top: 95%;
          left: 50%;
        }
      }
      .description p {
        opacity: 1;
        transform: translateY(20px);
      }
    }
  }
}
</style>

<script>
import Vue from 'vue'
import hero from '@/components/hero.vue'
import igFeed from '@/components/igFeed.vue'
import { db } from '@/db.js'
import { sortBy } from 'lodash'

export default Vue.extend({
  name: 'home',
  components: {
    hero,
    igFeed
  },
  metaInfo: {
    title: 'TD Lab',
    titleTemplate: null,
    meta: [
      { vmid: 'description', name: 'description', content: 'home' }
    ]
  },
  data () {
    return {
      projects: []
    }
  },
  computed: {
    featuredProjectsSorted () {
      return sortBy(this.featuredProjects, 'createdAt').reverse()
    },
    featuredProjects () {
      return this.projects.filter(project => {
        return project.featured && project.publish
      })
    }
  },
  mounted () {
    if (window.innerWidth >= 960) {
      this.$store.dispatch('navSetTransparent', true)
      this.$store.dispatch('navSetDark', true)
    }
  },
  beforeDestroy () {
    if (window.innerWidth >= 960) {
      this.$store.dispatch('navSetTransparent', false)
      this.$store.dispatch('navSetDark', false)
    }
  },
  firestore: {
    projects: db.collection('projects')
  }
})
</script>
